import { render, staticRenderFns } from "./CompanyChangeIndex.vue?vue&type=template&id=768c0e7f&"
import script from "./CompanyChangeIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyChangeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports